import React from 'react';
import Link from 'next/link';
import Styles from './styles.js';
const TitleSectionOne = ({ title, btnTxt, bg, href, hrefExt, spacing }) => {
  return (
    <>
      {bg == 'white' ? (
        <div className="w-full">
          <div className={spacing ? 'container mx-auto   py-4 my-2   ' : 'container mx-auto   py-4 my-4   '}>
            <div
              className={
                spacing
                  ? 'flex flex-col lg:flex-row pt-3 pb-3  justify-center items-center  '
                  : 'flex flex-col lg:flex-row pt-4 pb-3  justify-center items-center  '
              }>
              <div className=" lg:pr-4">
                <div>
                  <h3
                    className="uppercase font-normal md:text-[38px] text-[32px] lg:text-[48px] leading-[36px] md:leading-[43px] lg:leading-[54px]  text-center   text-[
                      #4e4646]"
                    style={{ fontFamily: "Josefin Sans",  }}>
                    {title}
                  </h3>
                </div>
              </div>
              <div className="  mt-3 text-center  md:mt-0">
                <div>
                  {href ? (
                    <Link href={href}>
                      <button
                        type="button"
                        className="btn font-semibold fs-16-18 rounded-0 "
                        style={{
                          fontFamily: 'Josefin Sans',
                          color: '#010101',
                          backgroundColor: '#FCBD00',

                          padding: '14px 32px',
                        }}>
                        {btnTxt}
                      </button>
                    </Link>
                  ) : (
                    <a href={hrefExt} target="_blank" rel="noreferrer">
                      <button
                        type="button"
                        className="btn font-semibold fs-16-18 rounded-0 "
                        style={{
                          fontFamily: 'Josefin Sans',
                          color: '#010101',
                          backgroundColor: '#FCBD00',

                          padding: '14px 32px',
                        }}>
                        {btnTxt}
                      </button>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full py-3" style={{ backgroundColor: 'rgb(22, 22, 22)' }}>
          <div className="container mx-auto py-5  ">
            <div className="flex flex-col lg:flex-row justify-center items-center ">
              <div className=" lg:pr-4">
                <div>
                  <h3
                    className="uppercase text-white text-[48px] leading-[54px]  font-normal  text-center"
                    style={{ fontFamily: 'Fjalla One',  }}>
                    {title}
                  </h3>
                </div>
              </div>
              <div className=" text-center lg:mt-0 mt-4">
                <div>
                  {href ? (
                    <Link href={href}>
                      <button
                        type="button"
                        className="btn font-semibold rounded-0 "
                        style={{
                          fontFamily: 'Josefin Sans',
                          color: '#010101',
                          backgroundColor: '#FCBD00',
                          fontSize: '18px',
                          padding: '13px 30px',
                        }}>
                        {btnTxt}
                      </button>
                    </Link>
                  ) : (
                    <a href={hrefExt} target="_blank" rel="noreferrer">
                      <button
                        type="button"
                        className="btn font-semibold rounded-0 "
                        style={{
                          fontFamily: 'Josefin Sans',
                          color: '#010101',
                          backgroundColor: '#FCBD00',
                          fontSize: '18px',
                          padding: '13px 30px',
                        }}>
                        {btnTxt}
                      </button>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Styles/>
    </>
  );
};

export default TitleSectionOne;
